import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Page, PageHeader } from '@/components/page'
import { useBasePath } from '@/lib/paths'
import { DocumentUploader } from '@/components/shared/DocumentUploader'
import { TemplateList } from '@/components/shared/TemplateList'

type Document = {
  id: string
  name: string
  file_url?: string | null
  blob_signed_id?: string | null
  filename?: string | null
  created_at: string
}

type Template = { id: string; name: string; file_url: string | null }

type Props = {
  formation: { id: string; legal_name: string }
  templates: Template[]
  application_documents: Document[]
  filing_documents: Document[]
  completion_documents: Document[]
}

export default function DocumentsShow({ formation, templates, application_documents, filing_documents, completion_documents }: Props) {
  const basePath = useBasePath()

  return (
    <DashboardLayout
      title={`Documents — ${formation.legal_name}`}
      breadcrumbs={[
        { label: 'Businesses', href: 'businesses' },
        { label: formation.legal_name, href: `formations/${formation.id}` },
        { label: 'Documents' }
      ]}
    >
      <Page>
        <PageHeader
          title={<>Documents</>}
          subtitle={
            <p className="text-sm text-muted-foreground">{formation.legal_name}</p>
          }
        />

        <div className="space-y-6">
          {/* Document templates */}
          <TemplateList title="Document templates" templates={templates || []} />

          {/* Application documents */}
          <DocumentUploader
            title="Application documents"
            documents={application_documents || []}
            uploadPath={`${basePath}/formations/${formation.id}/application_documents`}
            deletePath={(docId) => `${basePath}/formations/${formation.id}/application_documents/${docId}`}
          />

          {/* Filing documents */}
          {filing_documents.length > 0 && (
            <DocumentUploader
              title="Filing documents"
              documents={filing_documents}
              uploadPath={`${basePath}/formations/${formation.id}/filing_documents`}
              deletePath={(docId) => `${basePath}/formations/${formation.id}/filing_documents/${docId}`}
            />
          )}

          {/* Completion documents */}
          {completion_documents.length > 0 && (
            <DocumentUploader
              title="Completion documents"
              documents={completion_documents}
              uploadPath={`${basePath}/formations/${formation.id}/completion_documents`}
              deletePath={(docId) => `${basePath}/formations/${formation.id}/completion_documents/${docId}`}
            />
          )}
        </div>
      </Page>
    </DashboardLayout>
  )
}
